import React from "react";
import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import PathMap from "@/components/lib/PathMap";

const specialMenu = [
  {
    title: "Dish of The Day",
    path: "/backoffice/menu/special-menu/dish-the-day",
  },
  { title: "Sunday Roast", path: "/backoffice/menu/special-menu/sunday-roast" },

  {
    title: "Banquet Night",
    path: "/backoffice/menu/special-menu/banquet-night",
  },
  { title: "Buffet", path: "/backoffice/menu/special-menu/buffet" },
  {
    title: "Christmas Lunch/ Table",
    path: "/backoffice/menu/special-menu/christmas-lunch",
  },
  {
    title: "Party/Occasion Platter Sample",
    path: "/backoffice/menu/special-menu/party-platter-sample",
  },
];

function SpecialMenuLayout({ children }) {
  const { pathname } = useLocation();

  return (
    <div className="w-full">
      <PathMap
        pageName={{ title: "Special Menu" }}
        paths={[
          { name: "home", path: "/home" },
          { name: "Back Office", path: "/backoffice/overview" },
          { name: "Menu Management", path: "/backoffice/menu/drinks" },
          { name: "Special Menu", path: "/backoffice/menu/special-menu" },
        ]}
      />

      <div className="h-full container px-4 pb-1 mt-5">
        <div className="flex flex-wrap gap-4 items-center">
          {specialMenu?.map((item, val) => {
            return (
              <Link key={val} to={item.path}>
                <Button
                  className={`${
                    pathname === item.path ? "" : "bg-cblack7 text-cwhite"
                  }`}
                >
                  {item.title}
                </Button>
              </Link>
            );
          })}
        </div>
        <div className="mt-5">{children}</div>
      </div>
    </div>
  );
}

export default SpecialMenuLayout;
